
<template>
  <v-container fluid>
    <v-layout>
      <v-flex>
        <v-form>


          <v-layout mb-5 row wrap>
            <v-layout column>
                <v-flex md5 mr-5>
              <h3>Person Information</h3>
              <v-flex mt-2>

                <content-field
                  :label="formData.firstName.label"
                  :key="formData.firstName.label"
                  :hint="formData.firstName.hint"
                  :error="$v.formData.firstName.value"
                  @blur="$v.formData.firstName.value.$touch()"
                  v-model="formData.firstName.value"
                  required
                />

                <content-field
                  :label="formData.lastName.label"
                  :key="formData.lastName.label"
                  :hint="formData.lastName.hint"
                  :error="$v.formData.lastName.value"
                  @blur="$v.formData.lastName.value.$touch()"
                  v-model="formData.lastName.value"
                  required
                />

                <content-field
                  :label="formData.receiverEmail.label"
                  :key="formData.receiverEmail.label"
                  :hint="formData.receiverEmail.hint"
                  :error="$v.formData.receiverEmail.value"
                  @blur="$v.formData.receiverEmail.value.$touch()"
                  v-model="formData.receiverEmail.value"
                  required
                />

              </v-flex>
            </v-flex>

            <v-flex md5 mr-5>
              <h3>Super User Settings</h3>
              <v-flex mt-2>

                <content-field
                  :label="formData.superUserEmail.label"
                  :key="formData.superUserEmail.label"
                  :hint="formData.superUserEmail.hint"
                  :error="$v.formData.superUserEmail.value"
                  @blur="$v.formData.superUserEmail.value.$touch()"
                  v-model="formData.superUserEmail.value"
                />

                <content-field
                  :label="formData.superUserMessagesCount.label"
                  :key="formData.superUserMessagesCount.label"
                  :hint="formData.superUserMessagesCount.hint"
                  :error="$v.formData.superUserMessagesCount.value"
                  @blur="$v.formData.superUserMessagesCount.value.$touch()"
                  v-model="formData.superUserMessagesCount.value"
                  required
                />

              </v-flex>
            </v-flex>
            </v-layout>

            <v-flex md5>
              <h3>Invitation Settings Information</h3>
              <v-flex mt-2>

                <content-field
                  :label="formData.invitationName.label"
                  :key="formData.invitationName.label"
                  :hint="formData.invitationName.hint"
                  :error="$v.formData.invitationName.value"
                  @blur="$v.formData.invitationName.value.$touch()"
                  v-model="formData.invitationName.value"
                  required
                />

                <v-select
                  v-model="formData.templateKey.value"
                  :error-messages="isValid($v.formData.templateKey.value)"
                  :items="vipInvitationTemplatesList"
                  label="Vip Inviatiom email template"
                  item-value="templateKey"
                  item-text="templateKey"
                />

                <v-select
                  :label="attendeeTypeId.label"
                  :items="getVIPAttendeeTypes"
                  v-model="attendeeTypeId.value"
                  item-text="title"
                  item-value="id"
                  :error="$v.attendeeTypeId.value.$invalid"
                  @blur="$v.attendeeTypeId.value.$touch()"
                  :error-messages="($v.attendeeTypeId.value.$invalid && $v.attendeeTypeId.value.$dirty) ? ['Required'] : []"
                />

                <v-select
                  :label="formData.categoryType.label"
                  :items="categoriesTypes"
                  v-model="formData.categoryType.value"
                  :error="$v.formData.categoryType.value.$invalid"
                  @blur="$v.formData.categoryType.value.$touch()"
                  :error-messages="isValid($v.formData.categoryType.value)"
                />

                <v-select
                  :label="formData.categoryId.label"
                  :items="filteredCategories"
                  v-model="formData.categoryId.value"
                  item-text="name"
                  item-value="id"
                />

                <v-select
                  :label="packageId.label"
                  :items="filteredPackages"
                  v-model="packageId.value"
                  item-text="name"
                  item-value="id"
                  :error="$v.packageId.value.$invalid"
                  @blur="$v.packageId.value.$touch()"
                  :error-messages="isValid($v.packageId.value)"
                />

                <v-select
                  v-if="showTypeOfPaymentValue"
                  :label="formData.paymentType.label"
                  :items="typesOfPayment"
                  v-model="formData.paymentType.value"
                  :error="$v.formData.paymentType.value.$invalid"
                  @blur="$v.formData.paymentType.value.$touch()"
                  :error-messages="isValid($v.formData.paymentType.value)"
                />

                <content-field
                  :label="packagePrice.label"
                  :key="packagePrice.label"
                  :disabled="true"
                  :value="currentPrice"
                />

                <content-field
                  :label="formData.ticketsCount.label"
                  :key="formData.ticketsCount.label"
                  :hint="formData.ticketsCount.hint"
                  :error="$v.formData.ticketsCount.value"
                  @blur="$v.formData.ticketsCount.value.$touch()"
                  v-model="formData.ticketsCount.value"
                  required
                />

                <content-field
                  :label="formData.messageLimit.label"
                  :key="formData.messageLimit.label"
                  :hint="formData.messageLimit.hint"
                  :error="$v.formData.messageLimit.value"
                  @blur="$v.formData.messageLimit.value.$touch()"
                  v-model="messageLimit"
                  required
                />

                <content-field
                  :label="formData.boothNumber.label"
                  :key="formData.boothNumber.label"
                  :hint="formData.boothNumber.hint"
                  v-model="formData.boothNumber.value"
                  required
                />

                <h3>Unique link Settings</h3>
                <content-field
                  :label="formData.slug.label"
                  :key="formData.slug.label"
                  :hint="formData.slug.hint"
                  :error="$v.formData.slug.value"
                  @blur="$v.formData.slug.value.$touch()"
                  v-model="formData.slug.value"
                  required
                />

                <content-field
                  :label="formData.code.label"
                  :key="formData.code.label"
                  :hint="formData.code.hint"
                  :error="$v.formData.code.value"
                  @blur="$v.formData.code.value.$touch()"
                  v-model="formData.code.value"
                  required
                />

                <v-flex v-if="isInvitationLinkGenerated">
                  <h4>{{ `${eventLink}registration/${formData.slug.value}/${formData.code.value}` }}</h4>
                </v-flex>
              </v-flex>
            </v-flex>
          </v-layout>


          <!-- <v-layout mb-5 row wrap> -->
            <!-- <v-flex md5 mr-5>
              <h3>Blitz Settings</h3>
              <v-flex mt-2>

                <content-field
                  :label="formData.blitzUserName.label"
                  :key="formData.blitzUserName.label"
                  :hint="formData.blitzUserName.hint"
                  :error="$v.formData.blitzUserName.value"
                  @blur="$v.formData.blitzUserName.value.$touch()"
                  v-model="formData.blitzUserName.value"
                  required
                />

                <content-field
                  :label="formData.blitzUserEmail.label"
                  :key="formData.blitzUserEmail.label"
                  :hint="formData.blitzUserEmail.hint"
                  :error="$v.formData.blitzUserEmail.value"
                  @blur="$v.formData.blitzUserEmail.value.$touch()"
                  v-model="formData.blitzUserEmail.value"
                  required
                />

              </v-flex>
            </v-flex> -->

          <!-- </v-layout> -->

          <v-layout mb-5 row wrap>
            <v-flex md5 mr-5>
              <h3>Additional Features</h3>
              <v-flex mt-2>

          <v-layout row wrap>
            <v-flex xs12 sm4 mt-4><p>{{isKillerFeatureEnabled.label}}</p></v-flex>
            <v-flex xs12 sm8>
              <v-radio-group v-model="isKillerFeatureEnabled.value" row>
                <v-radio
                  :label="isKillerFeatureEnabled.options[0].text"
                  :key="isKillerFeatureEnabled.options[0].value"
                  :value="isKillerFeatureEnabled.options[0].value"
                />
                <v-radio
                  :label="isKillerFeatureEnabled.options[1].text"
                  :key="isKillerFeatureEnabled.options[1].value"
                  :value="isKillerFeatureEnabled.options[1].value"
                />
              </v-radio-group>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex xs12 sm4 mt-4><p>{{isPaidOffline.label}}</p></v-flex>
            <v-flex xs12 sm8>
              <v-radio-group v-model="isPaidOffline.value" row>
                <v-radio
                  :label="isPaidOffline.options[0].text"
                  :key="isPaidOffline.options[0].value"
                  :value="isPaidOffline.options[0].value"
                />
                <v-radio
                  :label="isPaidOffline.options[1].text"
                  :key="isPaidOffline.options[1].value"
                  :value="isPaidOffline.options[1].value"
                />
              </v-radio-group>
            </v-flex>
          </v-layout>

              </v-flex>
            </v-flex>

            <v-flex md5 v-if="showDiscountField">
              <h3>Discount Settings</h3>
              <v-flex mt-2>

              <v-radio-group v-model="discount" row>
                <v-radio
                  :label="discountTypes.discountInCurrency.label"
                  :key="discountTypes.discountInCurrency.name"
                  :value="discountTypes.discountInCurrency.name"
                />
                <v-radio
                  :label="discountTypes.discountInPercent.label"
                  :key="discountTypes.discountInPercent.name"
                  :value="discountTypes.discountInPercent.name"
                />
              </v-radio-group>

              <content-field
                :label="discountTypes[discount].label"
                :key="discountTypes[discount].name"
                :hint="discountTypes[discount].hint"
                v-model="discountTypes[discount].value"
                :error="$v.discountTypes[discount].value"
                @input="$v.discountTypes[discount].value.$touch()"
                @blur="$v.discountTypes[discount].value.$touch()"
                :customErrorMessages="errorMessages"
                required
              />

                <content-field
                  :label="discountTypes.newPrice.label"
                  :key="discountTypes.newPrice.label"
                  :disabled="true"
                  :value="newPriceAfterDiscount"
                />

                <p>Price without VatID</p>

                <content-field
                  :label="discountTypes.newPriceWithVatID.label"
                  :key="discountTypes.newPriceWithVatID.label"
                  :disabled="true"
                  :value="priceWithVatId"
                />

              </v-flex>
            </v-flex>
          </v-layout>

          <v-layout mb-5 row wrap>
            <v-flex md5 mr-5>
              <h3>Package Email Settings</h3>
              <v-flex mt-2>
                <v-layout row wrap>
                  <v-flex>
                    <v-select
                      v-model="packageEmailTemplates.confirmationEmailTemplateName"
                      :error-messages="isValid($v.packageEmailTemplates.confirmationEmailTemplateName)"
                      :items="registrationSuccesTemplatesList"
                      label="Confirmation email template"
                      item-value="templateKey"
                      item-text="templateKey"
                    />
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex>
                    <v-select
                      v-model="packageEmailTemplates.failedPaymentEmailTemplateName"
                      :items="registrationFailtureTemplatesList"
                      :error-messages="isValid($v.packageEmailTemplates.failedPaymentEmailTemplateName)"
                      label="Failed payment email template"
                      item-value="templateKey"
                      item-text="templateKey"
                    />
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex>
                    <v-select
                      :items="multipleTicketsSuccessBuyTemplatesList"
                      v-model="packageEmailTemplates.multiUserConfirmationEmailTemplateKey"
                      :error-messages="isValid($v.packageEmailTemplates.multiUserConfirmationEmailTemplateKey)"
                      label="Multiple user confirmation email template"
                      item-value="templateKey"
                      item-text="templateKey"
                    />
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex>
                    <v-select
                      :items="multipleTicketsFailedBuyTemplatesList"
                      v-model="packageEmailTemplates.multiUserFailedPaymentEmailTemplateKey"
                      :error-messages="isValid($v.packageEmailTemplates.multiUserFailedPaymentEmailTemplateKey)"
                      label="Multiple user failed email template"
                      item-value="templateKey"
                      item-text="templateKey"
                    />
                  </v-flex>
                </v-layout>

              </v-flex>
            </v-flex>
          </v-layout>
          <v-layout wrap row v-if="arePredefinedActivitiesExist">
            <v-flex md12>
              <h3>Change predefined activities: </h3>
              <v-switch
                label="Change activities"
                v-model="areActivitiesChanged"
              />
              <v-layout row wrap v-if="areActivitiesChanged">
                <v-flex xs12 class="my-4">
                  <div v-for="(value) in predefinedActivity" :key="`predefined-activity-${value.id}`">
                    <v-checkbox
                      v-model="selectedPredefinedActivities"
                      :label="value.title"
                      :value="value.id"
                    />
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-layout mt-5>
            <v-btn
              :disabled="$v.$invalid"
              @click="submit"
              color="success"
            >
              submit
            </v-btn>
            <v-btn
              @click="clear"
              color="error"
            >
              clear
            </v-btn>
          </v-layout>

        </v-form>
        <e-small-modal
          :isOn="getVIPLetter.showMessage"
          :link="getLink()"
          @close="onModalClose"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import {required, maxLength, email, numeric, between, maxValue, minValue, alpha} from 'vuelidate/lib/validators'
  import {mapGetters, mapActions} from 'vuex'
  import {repeat, map, mapObjIndexed, prop, clone, filter, equals, find, assocPath, propEq, path, pathOr, isEmpty, concat} from 'ramda'
  import ESmallModal from './modal'
  import mixins from '@/utils/mixins'

  const typesOfPayment = ['Single', 'Group']
  const categoriesTypes = ['Buy', 'Sell']

  export default {
    name: 'SingleInvitation',
    components: {
      ESmallModal
    },
    mixins: [mixins.emailTemplates],
    data() {
      return {
        typesOfPayment,
        temporal: {
          slug: '',
          code: ''
        },
        categoriesTypes,
        allCategories: [],
        filteredCategories: [],
        formData: {
          invitationName: {name: 'invitationName', label: 'Invitation name', hint: 'Please specify invitation title', value: ''},
          firstName: {name: 'firstName', label: 'First Name', hint: 'Please, enter recipient\'s name', value: ''},
          lastName: {name: 'lastName', label: 'Last Name', hint: 'Please, enter recipient\'s surname', value: ''},
          // blitzUserName: {
          //   name: 'blitzUserName',
          //   label: 'Blitz user name',
          //   hint: 'Please enter blitz user name',
          //   value: ''
          // },
          // blitzUserEmail: {
          //   name: 'blitzUserEmail',
          //   label: 'Blitz user email',
          //   hint: 'Please enter blitz user email',
          //   value: ''
          // },
          superUserEmail: {
            name: 'superUserEmail',
            label: 'SuperUser Email',
            hint: 'Please, enter super-user e-mail',
            value: ''
          },
          receiverEmail: {
            name: 'receiverEmail',
            label: 'Receiver Email',
            hint: 'Please, enter recipient\'s e-mail',
            value: ''
          },
          ticketsCount: {name: 'ticketsCount', label: 'Tickets Count', hint: 'Please, enter tickets count', value: 1},
          superUserMessagesCount: {
            name: 'superUserMessagesCount',
            label: 'SuperUser Message Count',
            hint: 'Please, enter super-user message count',
            value: 0
          },
          slug: {name: 'slug', label: 'Slug', hint: 'Please, enter slug', value: ''},
          code: {name: 'code', label: 'Code', hint: 'Please, enter code', value: null},
          messageLimit: {
            name: 'messageLimit',
            label: 'Message Limit',
            hint: 'Please, enter message limit',
            value: 200
          },
          boothNumber: {
            name: 'boothNumber',
            label: 'Booth Number',
            hint: 'Please, enter Booth number',
            value: null
          },
          categoryType: {
            name: 'categoryType',
            label: 'Type of Attendee Category',
            hint: 'Please, choose category type',
            value: categoriesTypes[0]
          },
          categoryId: {
            name: 'Category',
            label: 'Attendee Category',
            hint: 'Please, assign category',
            value: null
          },
          paymentType: {
            name: 'paymentType',
            label: 'Type of Payment Process',
            hint: 'Please, choose payment Type',
            value: typesOfPayment[0]
          },
          templateKey: { value: '' },
        },
        packageId: {name: 'packageId', label: 'Package Id', hint: 'Please, enter package id', value: 'none'},
        packagePrice: { name: 'packagePrice', label: 'Package Price' },
        attendeeTypeId: {
          name: 'attendeeTypeId',
          label: 'VIP Attendee type',
          hint: 'Please, vip attendee type',
          value: 'none'
        },
        discount: 'discountInCurrency',
        discountTypes: {
          discountInCurrency: {
            name: 'discountInCurrency',
            label: 'Discount in currency',
            hint: 'Please, enter recipient\'s discount in currency',
            value: 0
          },
          discountInPercent: {
            name: 'discountInPercent',
            label: 'Discount in percent',
            hint: 'Please, enter discount in percent',
            value: 0
          },
          newPrice: { name: 'newPrice', label: 'New Price' },
          newPriceWithVatID: { name: 'newPriceWithVatID', label: 'New price without VatID' }
        },
        isKillerFeatureEnabled: {
          label: 'Killer feature',
          hint: 'Please, decide if killer feature is enabled',
          value: true,
          options: [{text: 'enabled', value: true}, {text: 'disabled', value: false}]
        },
        isPaidOffline: {
          label: 'Paid offline',
          hint: 'Please, choose if recipient paid offline',
          value: false,
          options: [{text: 'yes', value: true}, {text: 'no', value: false}]
        },
        packageEmailTemplates: {
          confirmationEmailTemplateName: '',
          failedPaymentEmailTemplateName: '',
          multiUserConfirmationEmailTemplateKey: '',
          multiUserFailedPaymentEmailTemplateKey: ''
        },
        packages: [],
        filteredPackages: [],
        maxDiscountInCurrency: 0,
        currentPackage: null,
        areActivitiesChanged: false,
        selectedPredefinedActivities: []
      }
    },
    validations() {
      return {
        resetValue: {},
        formData: {
          invitationName: {value: {required}},
          firstName: {value: {required, maxLength: maxLength(20)}},
          lastName: {value: {required, maxLength: maxLength(20)}},
          superUserEmail: {value: {required, email}},
          receiverEmail: {value: {required, email}},
          // blitzUserName: {value: {required}},
          // blitzUserEmail: {value: {required, email}},
          ticketsCount: {value: {required, numeric}},
          superUserMessagesCount: {value: {required, numeric}},
          slug: {value: {required, alpha}},
          code: {value: {required, numeric}},
          messageLimit: {value: {required, numeric}},
          categoryType: {value: {required}},
          paymentType: {value: {required}},
          templateKey: {value: {required}},
        },
        packageId: {value: {required}},
        attendeeTypeId: {value: {required}},
        discountTypes: {
          discountInCurrency: {
            value: {
              maxValue: maxValue(this.maxDiscountInCurrency || 0),
              minValue: minValue(0)
            }
          },
          discountInPercent: {value: {between: between(0, 100)}}
        },
        packageEmailTemplates: {
          confirmationEmailTemplateName: { required },
          failedPaymentEmailTemplateName: { required },
          multiUserConfirmationEmailTemplateKey: { required },
          multiUserFailedPaymentEmailTemplateKey: { required }
        }
      }
    },
    computed: {
      ...mapGetters([
        'eventLink',
        'getVIPLetter',
        'enabledCategoriesList',
        'packagesList',
        'getVIPAttendeeTypes',
        'getSettings',
        'predefinedActivity',
        'categoriesList'
      ]),
      arePredefinedActivitiesExist () {
        return this.predefinedActivity.length
      },
      isInvitationLinkGenerated () {
        return this.formData.slug.value && this.formData.code.value
      },
      showDiscountField () {
        return this.maxDiscountInCurrency > 0
      },
      showTypeOfPaymentValue () {
        return !this.isPackageFree
      },
      errorMessages() {
        return [
          {
            type: 'between',
            message: 'This field should be between 0 and 100'
          },
          {
            type: 'maxValue',
            message: `This field should no more than ${this.maxDiscountInCurrency}`
          },
          {
            type: 'minValue',
            message: `This field should be more than 0`
          }
        ]
      },
      currentPrice () {
        return this.currentPackage
          ? parseFloat(parseFloat(this.currentPackage.price).toFixed(2))
          : 0
      },
      isPackageFree () {
        return this.currentPrice === 0
      },
      newPriceAfterDiscount () {
        const discont = parseInt(pathOr(false, [this.discount, 'value'], this.discountTypes))
        const checkedDiscontCurrency = discont ? discont : 0
        const checkedDiscontPercent = discont ? discont : 0
        const discountInCurrency = this.currentPrice - checkedDiscontCurrency
        const discountInPercent = this.currentPrice - this.currentPrice / 100 * checkedDiscontPercent
        const priceForOne = this.discount === 'discountInCurrency' ? discountInCurrency : discountInPercent
        const priceWithCount = priceForOne * parseInt(path(['ticketsCount', 'value'], this.formData))
        return priceWithCount ? parseFloat(priceWithCount.toFixed(2)) : ''
      },
      getVatId () {
        return pathOr(0, ['globalSetting', 'vatIdSettings', 'increasingPercent'], this.getSettings)
      },
      priceWithVatId () {
        const price = this.newPriceAfterDiscount + (this.newPriceAfterDiscount * this.getVatId)
        return parseFloat(parseFloat(price).toFixed(2))
      },
      packageType () {
        return this.currentPrice === 0 ? 'Free' : 'Paid'
      },
      messageLimit () {
        return !isEmpty(this.currentPackage)
          ? pathOr(200, ['messagesLimit'], this.currentPackage)
          : this.formData.messageLimit.value
      },
      invitationPredefinedActivities () {
        return this.areActivitiesChanged ? this.selectedPredefinedActivities : this.currentPackage.predefinedActivities
      }
    },
    watch: {
      'formData.categoryType.value': {
        handler () {
          this.filterAllCategories()
          this.filteredPackages = this.filterPackages()
        },
        immediate: true
      },
      'formData.categoryId.value': {
        handler () {
          this.filteredPackages = this.filterPackages()
        },
        immediate: true
      },
      categoriesList: {
        handler: function (newVal) {
          this.allCategories = clone(newVal)
          this.filterAllCategories()
        },
        deep: true
      },
      discount(newVal, oldVal) {
        this.discountTypes[oldVal].value = 0
      },
      getVIPAttendeeTypes(newVal) {
        this.attendeeTypeId.value = newVal[0].id
      },
      packagesList(newVal) {
        this.packages = newVal
        this.filteredPackages = this.filterPackages()
        this.packageId.value = this.filteredPackages[0].id
      },
      packageId: {
        handler: function (newPackageId) {
          this.currentPackage = find(currentPackage => equals(currentPackage.id, newPackageId.value), this.filteredPackages)
          this.maxDiscountInCurrency = this.currentPackage.price
        },
        deep: true
      }
    },
    methods: {
      ...mapActions([
        'sendVIPSingleLetter',
        'closeLetterModal',
        'getEnabledCategoriesList',
        'getPackagesList',
        'getPredefinedActivity',
        'fetchVIPAttendeeTypes',
        'getCategoriesList'
      ]),
      filterPackages () {
        let filteredPackagesWithVisibilityPublic = this.packages.filter((packageItem) => packageItem.visibility === 'Public' && packageItem['availableAttendeeType'].indexOf(path(['categoryType', 'value'], this.formData)) !== -1)
        if (this.formData.categoryId.value) {
          let packagesWithVisibilityCategory = this.packages.filter((packageItem) => packageItem.visibility === 'Category')
          let filteredPackagesWithVisibilityCategory = packagesWithVisibilityCategory.filter((packageItem)=>!!(find(propEq('id', path(['categoryId', 'value'], this.formData)), packageItem.categories)))
          return concat(filteredPackagesWithVisibilityCategory, filteredPackagesWithVisibilityPublic)
        } else {
          return filteredPackagesWithVisibilityPublic
        }
      },
      isValid (validationItem) {
        return validationItem.$dirty && validationItem.$invalid
          ? ['This field is required']
          : []
      },
      filterAllCategories () {
        this.filteredCategories = this.allCategories.filter((category) => {
          return category.status === 'Enabled' && category.categoryType === 'None' && category.type === path(['categoryType', 'value'], this.formData)
        })
      },
      async submit() {
        try {
          this.$v.$touch()
          if (this.$v.$invalid) return

          let currentDiscount = filter(
            type => !!type.value,
            this.discountTypes
          )

          if (!isEmpty(currentDiscount)) {
            currentDiscount[this.discount].value = this.getDiscountValue()
          }
          const allData = clone({
            ...this.formData,
            ...currentDiscount,
            originalPackageId: this.packageId,
            attendeeTypeId: this.attendeeTypeId,
            isKillerFeatureEnabled: this.isKillerFeatureEnabled,
            isPaidOffline: this.isPaidOffline,
            package: this.currentPackage
          })
          const dataToSend = mapObjIndexed(
            field => this.convertToNumber(prop(['value'], field)),
            allData
          )
          dataToSend.package = {
            ...dataToSend.package,
            ...this.packageEmailTemplates,
            price: this.currentPrice,
            type: this.packageType,
            predefinedActivities: this.invitationPredefinedActivities,
            name: path(['package', 'name'], allData),
            title: path(['package', 'title'], allData),
            status: path(['package', 'status'], allData),
            messagesLimit:  path(['package', 'messagesLimit'], allData)
          }
          dataToSend.templateKey = this.formData.templateKey.value
          this.temporal.slug = this.formData.slug.value
          this.temporal.code = this.formData.code.value
          if (this.isPackageFree) dataToSend.paymentType = null
          await this.sendVIPSingleLetter(dataToSend)
          this.clear()
        } catch (err) {
          console.error(err)
        }
      },
      clear() {
        this.$v.$reset()
        this.formData = clone(this.resetValue)

        /* it breaks down submit action in second time */
        // this.formData = map(field => {
        //   const newField = { ...field }
        //   newField.value = ''
        //   return newField
        // }, this.formData)
        // this.discountTypes = map(field => {
        //   const newField = { ...field }
        //   newField.value = ''
        //   return newField
        // }, this.discountTypes)
        // this.maxDiscountInCurrency = this.packages[0].price
        // this.isKillerFeatureEnabled.value = true
        // this.isPaidOffline.value = false
        // this.categoryType = this.categoriesTypes[0]
        // this.packageId.value = this.packages[0].id
        // this.attendeeTypeId.value = this.getVIPAttendeeTypes[0].id
        // this.discount = 'discountInCurrency'
      },
      getLink() {
        let link = ''
        if (this.getVIPLetter.showMessage) {
          link = `${this.getVIPLetter.invitationLink}/${this.temporal.slug}/${this.temporal.code}`
        }
        return link
      },
      onModalClose() {
        this.closeLetterModal()
        this.clear()
      },
      convertToNumber(field) {
        if (typeof field === 'string') {
          return isNaN(Number(field)) ? field : Number(field)
        }
        return field
      },
      getDiscountValue () {
        return this.discount === 'discountInPercent'
          ? this.discountTypes[this.discount].value / 100
          : this.discountTypes[this.discount].value
      }
    },
    async created() {
      this.resetValue = clone(this.formData)
      try {
        const payload = {page: 0, itemsOnPage: 9999}
        await Promise.all([
          this.getEnabledCategoriesList(),
          this.getPackagesList(),
          this.getPredefinedActivity(),
          this.fetchVIPAttendeeTypes(payload),
          this.getCategoriesList()
        ])
      } catch (err) {
        console.error(err)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/Registration/Invitation/single.vue